import React from 'react';
import { Tables, StatusBar } from '@deeptrue-frontend/ui';
import DeleteIcon from '@material-ui/icons/Delete';
import Tooltip from '@material-ui/core/Tooltip';
import RemoveModal from 'components/PromptModal/PromptModal';
import { ProjectStatus, TRANSLATED_STATUSES } from 'consts/statuses';
import { useFormatMessage } from 'components/IntlProvider';

const { TableRow, TableCell } = Tables;

interface Props {
  productName: string | null;
  status: number;
  name: string;
  id: number;
  removeProject: (id: number) => void;
}

const Project = ({ name, productName, status, id, removeProject }: Props) => {
  const t = useFormatMessage();

  return (
    <TableRow>
      <TableCell minWidth="150px" height="2rem" padding="0.5rem">
        {name}
      </TableCell>
      <TableCell height="2rem" padding="0.5rem">
        {productName}
      </TableCell>
      <TableCell height="2rem" padding="0.5rem">
        <StatusBar
          status={{
            value: ProjectStatus[status],
            text: TRANSLATED_STATUSES[status.toString()].statusText(t),
          }}
        />
      </TableCell>
      <TableCell height="2rem" padding="0.5rem" width="80px" align="right">
        <Tooltip title={t('organization.unshare', 'Unshare')}>
          <span style={{ cursor: 'pointer' }}>
            <RemoveModal
              onConfirm={() => removeProject(id)}
              renderer={({ handleOpen }: { handleOpen: any }) => (
                <DeleteIcon onClick={handleOpen} />
              )}
            >
              <>
                {t(
                  'organization.confirmUnshare',
                  'Are you sure you want to unshare this {x}',
                  {
                    x: t('organization.project', 'Project'),
                  }
                )}
              </>
            </RemoveModal>
          </span>
        </Tooltip>
      </TableCell>
    </TableRow>
  );
};

export default Project;
